import axios from "axios";
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";

const ProtectedRoute = ({ allowedRoles }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const localhost = process.env.REACT_APP_LOCALHOST;
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const res = await axios.get(localhost + "user", { headers: { Authorization: `Bearer ${token}` } });
        const data = res.data;
        if (data) {
          setUserRole(data.role);
        }
      } catch (err) {
        // console.error(err);
        navigate("/signin");
      }finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="loading-spinner" />
      </div>
    );
  }

  if (!userRole) {
    return <Navigate to="/signin" replace />;
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/signin" replace />;
  }

  return <Outlet />;
};

// Admin Route (Only for Admin)
export const AdminRoute = () => <ProtectedRoute allowedRoles={["admin"]} />;

// User & Admin Route (for both)
export const UserRoute = () => <ProtectedRoute allowedRoles={["user", "admin"]} />;